export var notInitialized=function notInitialized(){throw new Error('uSES not initialized!');};